import { render, staticRenderFns } from "./CampoRecursivo.vue?vue&type=template&id=1b01c006&scoped=true"
import script from "./CampoRecursivo.vue?vue&type=script&lang=js"
export * from "./CampoRecursivo.vue?vue&type=script&lang=js"
import style0 from "./CampoRecursivo.vue?vue&type=style&index=0&id=1b01c006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b01c006",
  null
  
)

export default component.exports